import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=ed3f6534&"
import script from "./ViewTicket.vue?vue&type=script&lang=js&"
export * from "./ViewTicket.vue?vue&type=script&lang=js&"
import style0 from "./ViewTicket.vue?vue&type=style&index=0&id=ed3f6534&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports